var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "boxInfo1" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "border-card", value: "first" },
          on: { "tab-click": _vm.handleClick },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.tabTitle, name: "first" } },
            [
              _c("Details", {
                attrs: {
                  "edit-data": _vm.editData,
                  "operation-type": _vm.operationType,
                  "copy-model": _vm.copyModel,
                },
                on: { saveData: _vm.saveChange },
              }),
            ],
            1
          ),
          _vm.isShowLog
            ? _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("basicData.OperationalLogs"),
                    name: "second",
                  },
                },
                [
                  _vm.isSecondActive
                    ? _c("operationLog", {
                        attrs: { "edit-data": _vm.editData },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }